import React from 'react'

const stats = [
  {
    label: 'Total Questions',
    valueKey: 'total',
    color: '#4E57EF',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M9.99963 1.51636C14.6849 1.51636 18.4829 5.31456 18.483 9.99976C18.483 14.6851 14.685 18.4822 9.99963 18.4822C8.66581 18.4839 7.35145 18.1699 6.16272 17.5662L3.02991 18.4402C2.87716 18.4828 2.71748 18.4949 2.56116 18.4753L2.40686 18.4451C2.25352 18.4048 2.11007 18.3347 1.98499 18.239L1.86682 18.1355C1.75478 18.0235 1.6658 17.8905 1.60608 17.7449L1.55627 17.5955C1.50267 17.3912 1.50442 17.1759 1.56116 16.9724L2.43616 13.8425C1.8306 12.6524 1.5145 11.3356 1.51624 9.99976L1.52795 9.56323C1.7553 5.08104 5.46096 1.51653 9.99963 1.51636ZM9.65588 3.07495C8.05658 3.15435 6.53331 3.78534 5.34631 4.86011L5.09729 5.09741C3.79712 6.39759 3.0671 8.16104 3.06702 9.99976C3.06702 11.1991 3.3711 12.3522 3.94202 13.3757L4.06702 13.6003L4.09729 13.6541L4.08069 13.7136L3.22522 16.7761L6.29163 15.9216L6.35022 15.905L6.40491 15.9343L6.62952 16.0593V16.0603L6.98108 16.2429C7.81272 16.6449 8.71805 16.877 9.64319 16.9246L10.0397 16.9333C10.9632 16.9279 11.8778 16.7376 12.7291 16.3728L13.0885 16.2068C13.9155 15.7951 14.6536 15.2219 15.2574 14.5193C15.9474 13.7164 16.4438 12.7657 16.7096 11.741L16.7985 11.3542C16.9531 10.578 16.9734 9.78098 16.859 8.9978L16.7906 8.60718C16.6045 7.69967 16.239 6.83963 15.7164 6.07788L15.483 5.75757C14.9162 5.02477 14.2086 4.41442 13.4039 3.96069L13.0533 3.77612C12.103 3.3097 11.0583 3.06734 9.99963 3.06714L9.65588 3.07495ZM9.99963 12.7664C10.2603 12.7664 10.5106 12.8702 10.6949 13.0544L10.7604 13.1267C10.9038 13.3016 10.983 13.5216 10.983 13.7498C10.983 13.9779 10.9037 14.1979 10.7604 14.3728L10.6949 14.4451C10.5105 14.6295 10.2604 14.7332 9.99963 14.7332C9.77146 14.7331 9.55152 14.6539 9.37659 14.5105L9.30432 14.4451C9.12012 14.2607 9.01624 14.0104 9.01624 13.7498C9.01632 13.4891 9.11999 13.2388 9.30432 13.0544L9.37659 12.989C9.55147 12.8458 9.7716 12.7664 9.99963 12.7664ZM9.99963 5.47534C10.6471 5.47534 11.2683 5.73239 11.7262 6.19019L11.8883 6.3689C12.2445 6.80345 12.442 7.34993 12.442 7.91675C12.442 8.35339 12.3769 8.70406 12.2252 9.03296C12.0746 9.35937 11.8427 9.6543 11.524 9.98608L11.5221 9.98804L11.3815 10.1306V10.1316C11.1224 10.3907 10.9736 10.5611 10.8873 10.7205C10.8052 10.8723 10.7751 11.0225 10.775 11.2498C10.775 11.4296 10.7122 11.6031 10.5992 11.741L10.5485 11.7976C10.4031 11.9429 10.2052 12.0251 9.99963 12.0251C9.79421 12.0251 9.59704 11.9429 9.45178 11.7976C9.30665 11.6523 9.22522 11.4551 9.22522 11.2498C9.22525 10.8134 9.28953 10.4632 9.44104 10.1345C9.59162 9.80801 9.82347 9.51229 10.1422 9.18042L10.1442 9.17847L10.2848 9.03589H10.2858L10.4596 8.8562C10.6146 8.69135 10.7143 8.56557 10.7789 8.44604C10.8611 8.29411 10.8912 8.1442 10.8912 7.91675V7.91577L10.8883 7.83081C10.8728 7.66083 10.8086 7.49869 10.7037 7.36401L10.6481 7.29956C10.5102 7.15371 10.3275 7.05917 10.1305 7.03003L10.0455 7.02124C9.84533 7.011 9.64842 7.06873 9.48596 7.18335L9.41858 7.23608C9.24482 7.38568 9.13533 7.59676 9.11292 7.82495L9.10803 7.92358C9.10647 8.10091 9.0447 8.27183 8.93323 8.40796L8.88147 8.4646C8.7362 8.60987 8.53905 8.69205 8.33362 8.69214C8.15386 8.69214 7.98028 8.62924 7.84241 8.51636L7.78577 8.4646C7.64043 8.31926 7.55823 8.12229 7.55823 7.91675C7.55823 7.26926 7.81527 6.64807 8.27307 6.19019C8.73089 5.73236 9.35218 5.47543 9.99963 5.47534Z"
          fill="white"
          stroke="white"
          stroke-width="0.3"
        />
      </svg>
    ),
  },
  {
    label: 'Correct Answers',
    valueKey: 'correct',
    color: '#3BBC4C',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 18.5713C9.2143 18.5713 8.50002 18.4999 7.7143 18.2856C7.64288 18.2856 7.57145 18.2142 7.50002 18.2142C3.92859 17.1428 1.42859 13.7856 1.42859 9.9999C1.42859 5.28561 5.28573 1.42847 10 1.42847C11.5714 1.42847 13.1429 1.85704 14.5 2.71418C14.8572 2.92847 14.9286 3.35704 14.7143 3.71418C14.5 4.07132 14.0714 4.14275 13.7143 3.92847C12.5714 3.21418 11.2857 2.85704 10 2.85704C6.07145 2.85704 2.85716 6.07132 2.85716 9.9999C2.85716 13.1428 4.92859 15.9285 8.00002 16.857H8.14288C8.78573 16.9999 9.42859 17.1428 10.0714 17.1428C14 17.1428 17.2143 13.9285 17.2143 9.9999C17.2143 9.35704 17.1429 8.71418 16.9286 8.07132C16.8572 7.71418 17.0714 7.28561 17.4286 7.21418C17.7857 7.14275 18.2143 7.35704 18.2857 7.71418C18.5 8.42847 18.5714 9.21418 18.5714 9.9999C18.5714 14.7142 14.7143 18.5713 10 18.5713Z"
          fill="white"
        />
        <path
          d="M7.8572 14.2855C7.64291 14.2855 7.50005 14.2141 7.3572 14.0712L4.50005 11.2141C4.21434 10.9284 4.21434 10.4998 4.50005 10.2141C4.78577 9.92836 5.21434 9.92836 5.50005 10.2141L7.8572 12.5712L17.3572 3.07122C17.6429 2.78551 18.0715 2.78551 18.3572 3.07122C18.6429 3.35693 18.6429 3.7855 18.3572 4.07122L8.35719 14.0712C8.21434 14.2141 8.07148 14.2855 7.8572 14.2855Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    label: 'Incorrect Answers',
    valueKey: 'incorrect',
    color: '#E90004',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M16.3451 3.65487C12.8555 0.135887 7.17386 0.112121 3.65487 3.60173C0.135887 7.09135 0.112121 12.773 3.60173 16.292C3.61937 16.3098 3.63707 16.3275 3.65487 16.3451C7.14452 19.8641 12.8261 19.8879 16.3451 16.3982C19.8641 12.9086 19.8879 7.22697 16.3982 3.70801C16.3806 3.69022 16.3629 3.67251 16.3451 3.65487ZM9.99997 17.7345C5.73517 17.7345 2.26546 14.2648 2.26546 10C2.26546 5.73524 5.73517 2.26553 9.99997 2.26553C14.2648 2.26553 17.7345 5.73524 17.7345 10C17.7345 14.2648 14.2648 17.7345 9.99997 17.7345Z"
          fill="white"
        />
        <path
          d="M13.4309 6.56914C13.189 6.32725 12.7968 6.32725 12.5549 6.56914L9.99999 9.12401L7.44512 6.56914C7.20319 6.32721 6.81098 6.32721 6.56905 6.56914C6.32712 6.81108 6.32712 7.20328 6.56905 7.44521L9.12392 10.0001L6.56905 12.555C6.32607 12.7958 6.32435 13.1881 6.5652 13.4311C6.80604 13.674 7.19828 13.6758 7.44126 13.4349L7.44512 13.4311L9.99999 10.8762L12.5549 13.4311C12.7987 13.6711 13.1909 13.668 13.4309 13.4242C13.6683 13.1831 13.6683 12.7961 13.4309 12.555L10.8761 10.0001L13.4309 7.44525C13.6728 7.20331 13.6728 6.81108 13.4309 6.56914Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    label: 'Omitted',
    valueKey: 'omitted',
    color: '#F36F4A',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10.0082 17.9997C8.78354 17.9997 7.63257 17.7484 6.58715 17.2526C6.27556 17.1048 6.14274 16.7324 6.29051 16.4208C6.43829 16.1092 6.8107 15.9764 7.1223 16.1242C12.8236 18.7546 18.7982 12.8482 16.0942 7.12091C15.7665 6.36471 16.8392 5.84898 17.2227 6.58583C19.7693 11.8215 15.8158 18.0479 10.0082 17.9997ZM3.62742 13.7548C3.93851 13.6059 4.06999 13.2331 3.92112 12.922C1.21032 7.23469 7.18537 1.20066 12.8941 3.9208C13.2057 4.06854 13.5781 3.93569 13.7258 3.62409C13.8736 3.3125 13.7408 2.94008 13.4292 2.7923C6.61482 -0.40719 -0.398153 6.67491 2.79466 13.4611C2.94396 13.7752 3.32325 13.9024 3.62742 13.7548ZM3.08128 17.8168L17.8181 3.07995C18.062 2.83608 18.062 2.44071 17.8181 2.19686C17.5743 1.95302 17.1789 1.95299 16.9351 2.19686L2.19819 16.9337C1.95431 17.1776 1.95431 17.573 2.19819 17.8168C2.44207 18.0607 2.83743 18.0607 3.08128 17.8168Z"
          fill="white"
        />
      </svg>
    ),
  },
]

const EnglishStatsCards = ({ statsData }) => (
  <div className="flex w-full gap-6 flex-nowrap justify-between items-stretch mt-8 mb-8">
    {stats.map((stat) => (
      <div
        key={stat.label}
        className="flex flex-row items-center bg-white border border-[#F0F0F0] rounded-[12px] shadow-sm flex-1 min-w-0 px-6 py-4"
        style={{ minHeight: 120 }}
      >
        <div
          className="flex-shrink-0 flex items-center justify-center w-12 h-12 mr-4"
          style={
            stat.label === 'Total Questions'
              ? {
                  borderRadius: '100px',
                  border: '1px solid #F0F0F0',
                  background: '#4E57EF',
                  width: 48,
                  height: 48,
                }
              : stat.label === 'Correct Answers'
              ? {
                  borderRadius: '100px',
                  border: '1px solid #F0F0F0',
                  background: '#3BBC4C',
                  width: 48,
                  height: 48,
                }
              : stat.label === 'Incorrect Answers'
              ? {
                  borderRadius: '100px',
                  background: '#E90004',
                  width: 48,
                  height: 48,
                }
              : stat.label === 'Omitted'
              ? {
                  borderRadius: '100px',
                  background: '#F36F4A',
                  width: 48,
                  height: 48,
                }
              : {}
          }
        >
          {stat.icon}
        </div>
        <div className="flex flex-col justify-center">
          <div
            className="mb-1"
            style={{
              color: '#030303',
              fontFamily: 'Basis Grotesque Arabic Pro',
              fontSize: 16,
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: '120%',
              letterSpacing: '-0.096px',
            }}
          >
            {stat.label}
          </div>
          <div
            style={{
              color: stat.color,
              fontFamily: 'Basis Grotesque Arabic Pro',
              fontSize: 40,
              fontStyle: 'normal',
              fontWeight: 500,
              lineHeight: '120%',
              letterSpacing: 0,
            }}
          >
            {statsData[stat.valueKey]}
          </div>
        </div>
      </div>
    ))}
  </div>
)

export default EnglishStatsCards
